var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMtnLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0429688 6C0.0429688 9.31371 2.72926 12 6.04297 12C9.35668 12 12.043 9.31371 12.043 6C12.043 2.68629 9.35668 0 6.04297 0C2.72926 0 0.0429688 2.68629 0.0429688 6Z",
    fill: "#FFCB05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6857 6.04129C11.6857 7.32226 9.16761 8.36059 6.06192 8.36059C2.95556 8.36059 0.4375 7.32226 0.4375 6.04129C0.4375 4.76033 2.95556 3.72266 6.06192 3.72266C9.16761 3.72266 11.6857 4.76033 11.6857 6.04129Z",
    fill: "#00678F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.46094 7.18649L3.04259 4.86719H3.97191V6.21795L4.58281 4.86719H5.54204L4.96105 7.18649H4.35015L4.69847 5.68948L3.97191 7.18649H3.47866V5.68948L3.09976 7.18649H2.46094Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73047 7.21564L5.81755 6.89258H6.48629L6.39854 7.21564H5.73047Z",
    fill: "#ED1D24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22656 7.18649L7.80755 4.86719H8.47629L8.76744 6.10096L9.08652 4.86719H9.69676L9.11577 7.18649H8.47629L8.15654 5.92413L7.8368 7.18649H7.22656Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73152 4.86719L5.58594 5.45482H6.19684L5.86779 6.72914H6.53586L6.86557 5.45482H7.47581L7.62073 4.86719H5.73152Z",
    fill: "#FFCB05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtnLogo);
export default __webpack_public_path__ + "static/media/MtnLogo.e46da30cde22ed85d3184c44c5185ef5.svg";
export { ForwardRef as ReactComponent };